import { jsx as i } from "react/jsx-runtime";
import c from "react-loading-skeleton";
function h(o) {
  const { width: t, height: e, count: r, circle: n } = o;
  return /* @__PURE__ */ i(c, { width: t, height: e, count: r, circle: n });
}
export {
  h as SkeletonLoader
};
//# sourceMappingURL=SkeletonLoader.mjs.map
